import { StyledContent } from '@/components/styles'
import { Picture } from '@/components'

const TitleContentImageBlock = ({ data }) => {
  const { content: htmlContent, image: imageFromProps } = data
  const image = imageFromProps || {}

  return (
    <>
      {htmlContent && (
        <StyledContent.Description>
          <StyledContent.Html dangerouslySetInnerHTML={{ __html: htmlContent }} dark/>
        </StyledContent.Description>
      )}

      {Object.keys(image).length > 0 && (
        <StyledContent.Img>
          <Picture {...image} />
        </StyledContent.Img>
      )}
    </>
  )
}

export default TitleContentImageBlock
